export default __webpack_public_path__ + "static/media/securedT.4774fbfc.jpg";